<template>
  <div class="export">
    <button @click="exportPTT">
      <span v-if="reportQuestionsDownloadControl[index]"><Loader color="#696969"/></span>

      <DownloadFile v-else />
    </button>

    <div class="text-hover">
      {{ parseTranslation(isWordCloud ? WORD_CLOUD : DOWNLOAD_CHART) }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import DownloadFile from '@/components/imgs/DownloadFile'

import Loader from '@/components/loading/Loader-3'

import { CHART_TYPES } from './chartConfig'
import { RESULT_TYPES } from '../questions.constants'

import * as translationDownloadChartButton from './downloadChartButtons.translations'

import { eventBus } from '@/main'

const { default: translations, ...translationKeys } = translationDownloadChartButton

export default {
  components: {
    DownloadFile,
    Loader,
  },

  props: {
    question_result: {
      type: Object,
      required: true,
    },

    index: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
    }
  },

  computed: {
    ...mapGetters(['reportQuestionsDownloadControl']),

    chartType() {
      const isWordCloud = this.question_result.resultType === CHART_TYPES.WORD_CLOUD

      if (isWordCloud) return CHART_TYPES.WORD_CLOUD
      return this.question_result?.chartSettings?.type || CHART_TYPES.BAR
    },

    isWordCloud() {
      return this.question_result.resultType === RESULT_TYPES.WORD_CLOUD
    },
  },

  methods: {
    exportPTT() {
      const exportChart = `${this.chartType}ExportChart`

      eventBus.$emit(exportChart, this.index)
    },
  },
}
</script>

<style lang="scss" scoped>
.export {
  margin-right: 30px;
  position: relative;

  button {
    @include flexAlignCenter;
    background: $transparent;
    border: none;
    @include tipography(18);
    font-weight: bold;
    color: $gray-2;

    svg {
      height: 25px;
    }
  }

  &:hover {
    .text-hover {
      display: block;
    }
  }
}
</style>
